import(/* webpackMode: "eager" */ "/opt/bengkel/ui/ui-bengkel/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/bengkel/ui/ui-bengkel/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bengkel/ui/ui-bengkel/src/components/landing/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bengkel/ui/ui-bengkel/src/components/landing/LandingNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bengkel/ui/ui-bengkel/src/components/landing/QueuePreview.tsx");
;
import(/* webpackMode: "eager" */ "/opt/bengkel/ui/ui-bengkel/src/components/landing/Reveal.tsx");
